import { Link } from 'react-router-dom';

const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=art.kalamanch.app';
const STARTUP_RECOGNITION_LINE = 'KalaManch.art is a product of Tivaro LLP, recognized by DPIIT under the Startup India initiative, Government of India, and recognized as a startup by the Department of IT & Electronics, Government of Uttar Pradesh.';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-[#4A148C] to-[#6A1B9A] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="text-3xl font-bold mb-4">KalaManch.Art</div>
            <p className="text-gray-200 mb-4 text-base">
              Bharat&apos;s premier digital stage for creative talent. Connecting artists with opportunities.
            </p>
            <div className="mb-6 rounded-2xl border border-white/15 bg-white/10 p-4">
              <p className="mb-3 text-sm font-semibold text-white">KalaManch mobile app</p>
              <div className="flex flex-col gap-3 sm:flex-row">
                <a href={ANDROID_PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className="block w-full max-w-[13rem]" data-testid="footer-app-google-play">
                  <img src="/images/store/google-play-badge.svg" alt="Get KalaManch on Google Play" className="w-full rounded-xl bg-white shadow-sm" />
                </a>
                <Link to="/mobile-app" className="block w-full max-w-[13rem]" data-testid="footer-app-app-store">
                  <img src="/images/store/app-store-badge.svg" alt="Download KalaManch on the App Store" className="w-full rounded-xl bg-white shadow-sm" />
                </Link>
              </div>
              <Link to="/mobile-app" className="mt-3 inline-flex text-sm font-semibold text-[#A7F3D0] hover:text-white">
                See app features for artists and collaborators
              </Link>
            </div>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/kalamanch.art"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-link-facebook"
                className="hover:text-[#00BFA5] transition-colors duration-200"
                aria-label="Facebook"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a
                href="https://x.com/kalamanchart"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-link-x"
                className="hover:text-[#00BFA5] transition-colors duration-200"
                aria-label="X"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2H21.5l-7.11 8.128L22.75 22h-6.547l-5.128-6.708L5.2 22H1.94l7.604-8.69L1.5 2h6.713l4.635 6.12L18.244 2zm-1.143 18h1.804L7.234 3.895H5.299L17.101 20z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/kalamanch.art/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-link-instagram"
                className="hover:text-[#00BFA5] transition-colors duration-200"
                aria-label="Instagram"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />
                </svg>
              </a>
              <a
                href="https://www.threads.com/@kalamanch.art"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-link-threads"
                className="hover:text-[#00BFA5] transition-colors duration-200"
                aria-label="Threads"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.73 10.4c-.11-.06-.23-.12-.35-.17-.2-1.36-.75-2.43-1.64-3.18-.97-.81-2.25-1.22-3.81-1.22-3.3 0-5.52 2.02-5.52 5.02 0 2.56 1.64 4.24 4.18 4.24 2.04 0 3.4-.93 4.08-2.77.2-.56.3-1.18.31-1.87.64.31 1.12.69 1.46 1.13.38.49.57 1.1.57 1.82 0 1.1-.35 1.98-1.05 2.65-.72.68-1.74 1.02-3.07 1.02-1.25 0-2.3-.27-3.14-.82-.83-.55-1.34-1.33-1.55-2.35H5.7c.16 1.56.88 2.82 2.17 3.79 1.28.96 2.95 1.44 5.01 1.44 2.11 0 3.82-.54 5.12-1.61 1.31-1.08 1.96-2.57 1.96-4.47 0-1.33-.31-2.43-.93-3.3-.33-.46-.76-.86-1.3-1.2Zm-3.55 1.27c-.01.69-.09 1.28-.24 1.79-.38 1.25-1.18 1.87-2.4 1.87-.85 0-1.5-.26-1.95-.78-.44-.53-.66-1.22-.66-2.09 0-1.1.28-1.95.85-2.55.56-.61 1.36-.91 2.4-.91.91 0 1.62.22 2.14.65.47.39.77.92.9 1.59-.33-.06-.67-.09-1.04-.09v2.43Z" />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@KalaManchArt"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-link-youtube"
                className="hover:text-[#00BFA5] transition-colors duration-200"
                aria-label="YouTube"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-2">
              <li>
                <Link to="/" data-testid="footer-link-home" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/indian-art" data-testid="footer-link-indian-art" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  Indian Art
                </Link>
              </li>
              <li>
                <Link to="/artists" data-testid="footer-link-artists" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  Browse Artists
                </Link>
              </li>
              <li>
                <Link to="/collaborators" data-testid="footer-link-collaborators" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  Collaborators
                </Link>
              </li>
              <li>
                <Link to="/collab-match" data-testid="footer-link-collab-finder" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  Collab Finder
                </Link>
              </li>
              <li>
                <Link to="/event-planner" data-testid="footer-link-event-planner" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  Event Planner
                </Link>
              </li>
              <li>
                <Link to="/competitions" data-testid="footer-link-competitions" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  Competitions
                </Link>
              </li>
              <li>
                <Link to="/live-auditions" data-testid="footer-link-live-auditions" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  Live Auditions
                </Link>
              </li>
              <li>
                <Link to="/projects" data-testid="footer-link-projects" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/about" data-testid="footer-link-about" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" data-testid="footer-link-contact" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/faq" data-testid="footer-link-faq" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/ai-studio" data-testid="footer-link-ai-studio" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  AI Studio
                </Link>
              </li>
              <li>
                <Link to="/mobile-app" data-testid="footer-link-mobile-app" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  Mobile App
                </Link>
              </li>
              <li>
                <Link
                  to="/media-kit"
                  data-testid="footer-link-media-kit"
                  className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base"
                >
                  Media Kit
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2 text-gray-200 text-base">
              <li data-testid="footer-email">me@kalamanch.art</li>
              <li data-testid="footer-address">Ghaziabad, India</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" data-testid="footer-link-privacy-policy" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" data-testid="footer-link-terms" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/trust-safety" data-testid="footer-link-trust-safety" className="text-gray-200 hover:text-[#00BFA5] transition-colors duration-200 text-base">
                  Trust & Safety
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-center text-gray-200 text-sm">
          <a
            href="/media/Kalamanch_Media_Kit_v1.0.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="mb-3 inline-flex items-center justify-center rounded-full border border-white/30 px-4 py-2 text-sm font-semibold text-white transition-colors duration-200 hover:border-[#00BFA5] hover:text-[#00BFA5]"
          >
            Download KalaManch Media Kit
          </a>
          <p className="mx-auto mb-3 max-w-4xl text-sm font-semibold leading-6 text-white">
            {STARTUP_RECOGNITION_LINE}
          </p>
          <p data-testid="copyright-text">
            &copy; 2026 KalaManch.art | Owned &amp; operated by{' '}
            <a href="https://tivaro.co.in/" target="_blank" rel="noopener noreferrer" className="font-semibold text-white underline underline-offset-4 hover:text-[#00BFA5]">
              Tivaro LLP
            </a>
            . All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

